module.exports = __webpack_public_path__ + "static/media/Fingerprint-pana.8bc245a7.svg";